import icons from '@constants/icons';

export default icons;
